import { Injectable } from "@angular/core";
import { CanLoad, Route, UrlSegment, UrlTree } from "@angular/router";
import { Observable, of } from "rxjs";

@Injectable({
  providedIn: "root",
})

export class AuthGaurd implements CanLoad {
  constructor() {}
  canLoad(): Observable<boolean> {
    const userData = JSON.parse(localStorage.getItem("user")) 
    const isLoggedIn = userData.result.accessToken ? true : false
    return of(isLoggedIn);
  }
}
